/* eslint-disable @typescript-eslint/no-explicit-any */
import { Col, Row } from '@design-system/components/grid/grid';
import { FormRowHeader, StyleSchema } from './common/FormRows';
import { useRowStyle } from './common/useRowStyle';
import { ActionableItemList } from './common/ActionableItemList';
import {
  CollapsibleWorkoutHeader,
  HeaderContent,
} from './common/WorkoutHeader';
import * as styles from './TabataExercise.css';
import { ExerciseRenderer } from './Workout';
import { ExerciseDetails, ExerciseMedia } from './common/ExerciseDetails';
import { AMRAPSwitch } from './common/AMRAPSwitch';
import { useSubExerciseVM } from '../../view-model/subexercise.viewmodel';
import { WorkoutItemMenu } from '@client/new/pages/workout/components/WorkoutItemMenu';
import { workoutVM } from '@client/new/pages/workout/WorkoutEdit';
import { Errors } from '@client/new/pages/promotions/view/components/Errors';
import { SetRenderer } from './common/SetRenderer';
import { HIITExerciseSetDTO } from '../../model/workout.domain';

const styleSchema: Array<StyleSchema> = [
  {
    width: 52,
    title: 'Round',
    tooltip: 'The effort user will perform during one round for this exercise',
  },
  { width: 87, title: 'Time' },
  { title: 'Reps' },
  { width: 87, title: 'Rest' },
];

export const HIITExercise: ExerciseRenderer = (p) => {
  const workout = workoutVM.useValue();
  const ex = useSubExerciseVM(workout, p.id);

  const style = useRowStyle({
    //todo: remove
    styleSchema,
  });

  return (
    <CollapsibleWorkoutHeader
      className={styles.wrapper}
      Header={<HeaderContent title={ex.name || 'HIIT'} />}
      defaultOpen={true}
      Action={
        <WorkoutItemMenu
          items={ex.menuItems}
          isCircuit
          // readonly={readonly}
        />
      }
      variant="secondary"
    >
      <Row className={styles.errorsWrapper}>
        <Errors data={ex.errors} />
      </Row>
      <Row className={styles.content}>
        <ExerciseMedia exercise={ex} />
        <Col style={{ gridArea: 'description' }}>
          <ExerciseDetails exercise={ex} />
        </Col>
        <Col style={{ gridArea: 'set' }}>
          <FormRowHeader styleSchema={styleSchema} style={style} />
          <ActionableItemList
            data={ex.fieldsWithSets}
            rowStyle={style}
            render={(d, id2) => (
              <SetRenderer
                index={id2}
                register={ex.register}
                data={d as HIITExerciseSetDTO}
              />
            )}
            action={(i) => <></>}
            minimumItems={1}
          />

          <Col style={{ alignItems: 'flex-start' }}>
            <AMRAPSwitch
              onChange={ex.lazyDispatch('SetAMRAP')}
              value={ex.isAMRAP}
            />
          </Col>
        </Col>
      </Row>
    </CollapsibleWorkoutHeader>
  );
};
